export default __webpack_public_path__ + "static/media/icon-video.fbb96dc5.svg";